import {render} from 'react-dom';
import {Provider} from 'react-redux';

import {createStore} from '../utils/redux';

import reducer from './reducer';
import UserNotificationStore from './UserNotificationStore';

import UserNotifications from './components/UserNotifications';

const UserNotificationsNode = document.getElementById('user-notifications');
const CSRFMiddlewareTokenNode = UserNotificationsNode.getElementsByTagName('input')[0];
const CSRFMiddlewareToken = CSRFMiddlewareTokenNode.value;

const store = createStore(reducer, 'Start');

window.UserNotificationStore = UserNotificationStore(
    CSRFMiddlewareToken,
    store.dispatch,
    () => render(
        <Provider store={store}>
            <UserNotifications />
        </Provider>,
        UserNotificationsNode,
    ),
);
